import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CurrencyCard from '../components/CurrencyCard';
import { FaSyncAlt } from 'react-icons/fa';
import { formatSourceUpdate } from '../utils/marketStatus';
import { CURRENCY_DISPLAY_ORDER, dedupeAndSortAssets } from '../utils/assetDisplayOrder';

const DovizPage = () => {
  const [currencies, setCurrencies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCurrencies();
    const interval = setInterval(fetchCurrencies, 5 * 60 * 1000); // 5 dakika
    return () => clearInterval(interval);
  }, []);

  const fetchCurrencies = async () => {
    try {
      const { data } = await axios.get('/api/currency');
      // Sadece category'si 'doviz' olanları göster
      const allowed = new Set(CURRENCY_DISPLAY_ORDER);
      const dovizler = dedupeAndSortAssets(data.filter(c => c.category === 'currency'))
        .filter(c => allowed.has(c.code));
      setCurrencies(dovizler);
      setLoading(false);
    } catch (error) {
      console.error('Döviz kurları yüklenemedi:', error);
      setLoading(false);
    }
  };

  const latestCurrency = currencies.reduce((latest, currency) => {
    if (!latest) return currency;
    return new Date(currency.fetchedAt || 0) > new Date(latest.fetchedAt || 0) ? currency : latest;
  }, null);
  const currentSource = latestCurrency?.source || 'TRUNCGIL';
  const sourceLabel = currentSource === 'TCMB' ? 'TCMB' : 'Trunçgil';

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 py-8 transition-colors duration-300 ease-in-out">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-2">Döviz</h1>
          <p className="text-gray-600 dark:text-gray-300 flex items-center space-x-2">
            <FaSyncAlt className="text-primary-600 dark:text-primary-400" />
            <span>{sourceLabel} kaynak zamanı: {formatSourceUpdate(latestCurrency)}</span>
            <span className="text-slate-500 dark:text-slate-400 font-medium">{currentSource === 'TCMB' ? 'Gösterge kuru' : 'Piyasa kuru'}</span>
          </p>
          {currentSource !== 'TCMB' && (
            <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">TCMB gösterge kuru günlük karşılaştırma için kullanılır.</p>
          )}
        </div>

        {loading ? (
          <div className="flex justify-center items-center py-20">
            <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary-600"></div>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6">
            {currencies.map((currency) => (
              <CurrencyCard key={currency.code} currency={currency} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default DovizPage;
